import { render, staticRenderFns } from "./TradingNew.vue?vue&type=template&id=97e9db64&scoped=true&"
import script from "./TradingNew.vue?vue&type=script&lang=js&"
export * from "./TradingNew.vue?vue&type=script&lang=js&"
import style0 from "./TradingNew.vue?vue&type=style&index=0&id=97e9db64&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97e9db64",
  null
  
)

export default component.exports